"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedInSearchPosts = exports.linkedInSearchPostsResultSchema = exports.linkedInPostSchema = exports.linkedInSearchPostsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Args schema
exports.linkedInSearchPostsArgsSchema = zod_1.z.object({
    query: zod_1.z.string().describe('Search query to find LinkedIn posts'),
    limit: zod_1.z.number().nullish().describe('Maximum number of posts to return').default(10),
    sortby: zod_1.z
        .enum(['date_posted', 'relevance'])
        .nullish()
        .describe('Sort order for search results')
        .default('relevance'),
    datePosted: zod_1.z
        .enum(['past-24h', 'past-week', 'past-month', 'all-time'])
        .nullish()
        .describe('Filter posts by date posted')
        .default('all-time'),
});
// Result schema
exports.linkedInPostSchema = zod_1.z.object({
    urn: zod_1.z.string().describe('Unique identifier for the post'),
    url: zod_1.z.string().describe('URL of the LinkedIn post'),
    title: zod_1.z.string().nullish().describe('Title of the post'),
    text: zod_1.z.string().describe('Text content of the post'),
    imageUrl: zod_1.z.string().nullish().describe('Main image URL of the post'),
    postedAtTimestamp: zod_1.z.number().describe('Timestamp when the post was created'),
    authorName: zod_1.z.string().describe('Name of the post author'),
    authorType: zod_1.z.string().describe('Type of the author'),
    authorProfileUrl: zod_1.z.string().describe('LinkedIn profile URL of the author'),
    authorFollowersCount: zod_1.z // For some reason, if this is a number it'll break the schema parsing
        .string()
        .nullish()
        .describe('Number of followers the author has'),
    authorHeadline: zod_1.z.string().nullish().describe('Professional headline of the author'),
    author: zod_1.z.union([
        zod_1.z.object({
            name: zod_1.z.string().nullish().describe('Author name'),
            universalName: zod_1.z.string().nullish().describe('Author universal name'),
            logoUrl: zod_1.z.string().nullish().describe('Author logo/avatar URL'),
        }),
        zod_1.z.object({
            firstName: zod_1.z.string().nullish().describe('Author first name'),
            lastName: zod_1.z.string().nullish().describe('Author last name'),
            occupation: zod_1.z.string().nullish().describe('Author occupation'),
            picture: zod_1.z.string().nullish().describe('Author profile picture'),
            publicId: zod_1.z.string().nullish().describe('Author public ID'),
        }),
    ]),
    type: zod_1.z.string().nullish().describe('Type of the post'),
    activityDescription: zod_1.z.string().nullish().describe('Description of the activity'),
    article: zod_1.z
        .object({
        title: zod_1.z.string().describe('Article title'),
        url: zod_1.z.string().nullish().describe('Article URL'),
    })
        .nullish()
        .describe('Article information if post contains an article'),
    image: zod_1.z.string().nullish().describe('Post image URL'),
    images: zod_1.z.array(zod_1.z.string()).nullish().describe('Array of post image URLs'),
    linkedinVideo: zod_1.z.string().nullish().describe('LinkedIn video URL if the post contains a video'),
    numComments: zod_1.z.number().describe('Number of comments on the post'),
    numLikes: zod_1.z.number().describe('Number of likes on the post'),
    numShares: zod_1.z.number().describe('Number of shares of the post'),
    comments: zod_1.z.array(zod_1.z.object({
        text: zod_1.z.string().describe('Comment text'),
        time: zod_1.z.number().describe('Time posted'),
        pinned: zod_1.z.boolean().describe('Is this comment pinned'),
        link: zod_1.z.string().describe('Link to the comment'),
    })),
    reactions: zod_1.z
        .array(zod_1.z.object({
        type: zod_1.z.string().describe('Type of reaction'),
        company: zod_1.z
            .object({
            name: zod_1.z.string().describe('Name of the person who reacted'),
            universalName: zod_1.z.string().describe('Universal name of the person who reacted'),
            logoUrl: zod_1.z.string().describe('Logo/avatar URL of the person who reacted'),
        })
            .nullish()
            .describe('Company information of the person who reacted'),
        profile: zod_1.z
            .object({
            firstName: zod_1.z.string().describe('First name of the person who reacted'),
            lastName: zod_1.z.string().describe('Last name of the person who reacted'),
            occupation: zod_1.z.string().describe('Occupation of the person who reacted'),
            publicId: zod_1.z.string().describe('Public ID of the person who reacted'),
        })
            .nullish()
            .describe('Profile information of person who reacted'),
    }))
        .describe('Array of reactions to the post'),
});
exports.linkedInSearchPostsResultSchema = zod_1.z.object({
    posts: zod_1.z.array(exports.linkedInPostSchema).describe('Array of LinkedIn posts'),
});
// Tool metadata
exports.linkedInSearchPosts = (0, common_1.createToolMetadata)({
    id: 'linkedInSearchPosts',
    displayName: 'LinkedIn Post Search',
    displayDescription: 'Search for LinkedIn posts by query, with options for sorting and date filtering',
    category: 'social',
    color: common_1.BRAND_COLORS.LINKEDIN,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.LINKEDIN),
    icon: 'linkedin',
    argsSchema: exports.linkedInSearchPostsArgsSchema,
}, exports.linkedInSearchPostsResultSchema);
